<template lang="html">
<div>
    <table class="se-table">
        <thead>
            <tr>
                <th class="se-col-check">
                    <input
                        type="checkbox"
                        :checked="allSelected"
                        :disabled="busy || pausableIds.length === 0"
                        title="Select all"
                        @change="toggleAll($event.target.checked)"
                    >
                </th>
                <th>Offer ID</th>
                <th>Offer name</th>
                <th>Affise ID</th>
                <th>SL ID</th>
                <th>SL name</th>
                <th>Ad set ID</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in items" :key="item.offer_id" class="se-row">
                <td class="se-col-check">
                    <input
                        type="checkbox"
                        :value="item.offer_id"
                        :disabled="busy || !canPause(item)"
                        :title="pauseTitle(item)"
                        v-model="selected"
                    >
                </td>
                <td class="se-mono">{{ item.offer_id }}</td>
                <td>{{ item.offer_name }}</td>
                <td class="se-mono">{{ item.affise_id }}</td>
                <td><span class="se-id">#{{ item.sl_id }}</span></td>
                <td>
                    <a class="se-link" :href="slHref(item)" target="_blank" rel="noopener">{{ item.sl_name }}</a>
                </td>
                <td>
                    <a class="se-link" :href="adSetHref(item)" target="_blank" rel="noopener">#{{ item.ad_set_id }}</a>
                </td>
            </tr>
        </tbody>
    </table>

    <button
        v-if="selected.length > 0"
        type="button"
        class="se-btn se-btn--danger"
        :disabled="busy"
        @click="$emit('pause', selected)"
    >
        Pause selected ({{ selected.length }})
    </button>
</div>
</template>

<script>
import '../views/search-entities.css'

export default {
    name: 'PausableOffersTable',
    props: {
        items: {
            type: Array,
            required: true
        },
        busy: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selected: []
        }
    },
    computed: {
        pausableIds() {
            return this.items.filter(this.canPause).map(v => v.offer_id)
        },
        allSelected() {
            return this.pausableIds.length > 0 && this.pausableIds.length === this.selected.length
        }
    },
    watch: {
        items: {
            deep: true,
            handler() {
                this.selected = this.selected.filter(id => {
                    const item = this.items.find(v => v.offer_id === id)
                    return item && this.canPause(item)
                })
            }
        }
    },
    methods: {
        canPause(item) {
            return item.weight > 0 && !item.is_rotating
        },
        pauseTitle(item) {
            if (item.is_rotating) {
                return 'This ad set is on offer rotation'
            }
            if (item.weight === 0) {
                return 'Already paused'
            }
            return ''
        },
        toggleAll(checked) {
            this.selected = checked ? this.pausableIds : []
        },
        slHref(item) {
            return '/apps/smartlinks/campaigns/' + item.sl_id
        },
        adSetHref(item) {
            return '/apps/smartlinks/campaigns/' + item.sl_id + '/placements/' + item.ad_set_id
        }
    }
}
</script>
